'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$158() {
  this.c2c = null;
  this.c2d = false;
}
export { $c_Lpresto_types$$anon$158 as $c_Lpresto_types$$anon$158 };
$p = $c_Lpresto_types$$anon$158.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$158;
/** @constructor */
function $h_Lpresto_types$$anon$158() {
}
export { $h_Lpresto_types$$anon$158 as $h_Lpresto_types$$anon$158 };
$h_Lpresto_types$$anon$158.prototype = $p;
$p.P = (function() {
  if ((!this.c2d)) {
    this.c2c = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c2d = true;
  }
  return this.c2c;
});
var $d_Lpresto_types$$anon$158 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$158, "presto.types$$anon$158", ({
  Y6: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$158 as $d_Lpresto_types$$anon$158 };
//# sourceMappingURL=presto.types$$anon$158.js.map
